var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-78.58515 -203.242 681.0713 1219.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.93 0L261.226 232.302H0L130.614 0H391.93",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M261.226 232.302h261.318L391.93 0H130.614z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.614 464.514l130.612-232.212L130.614 0 0 232.302z",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.879 812.967l130.704-232.303h261.318L393.196 812.967H131.879",
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.582 580.665H1.265l130.613 232.303h261.317z",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M393.196 348.453L262.582 580.665l130.614 232.303L523.9 580.665z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.e09d3e94c365aef030e2117fcf34f7a8.svg";
export { ForwardRef as ReactComponent };